<template>
  <div class="police-log">
    <div class="police-log-title flex-space-between">
      <span class="title">警情日志</span>
      <ul>
        <li
          v-for="(item, index) in tabTypes"
          :key="index"
          :class="{ active: tabType === index }"
          @click="handleTabChange(index)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
    <div class="police-log-list" ref="logList">
      <ul>
        <li v-for="(item, index) in policeLogList" :key="index">
          <div class="flex-space-between">
            <h3>{{ item.orgName }}</h3>
            <span>{{ getDates(item.ctime, "year") }}</span>
            <!-- <span>{{ tabType=='0'?item.ctime:tabType=='1'?item.faultTime:tabType=='2'?item.faultTime }}</span> -->
          </div>
          <div class="text">{{ item.content }}</div>
        </li>
      </ul>
      <div style="min-height: 50px; position: relative">
        <Spin fix v-if="loading" style="background-color:rgba(0,0,0,0)">加载中...</Spin>
      </div>
      <div v-if="noMoreData" class="no-more-data">没有更多数据了</div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getDate } from "@/libs/tools";

export default {
  name: "PoliceLog",
  props: {
    orgId: String | Number,
    moduleId: String | Number,
    intervalIndex: Number,
  },
  data() {
    return {
      tabType: 0,
      policeLogList: [],
      currentPage: 1,
      pageSize: 10,
      loading: false,
      noMoreData: false,
      scrollTimer: null,
      tabTypes: [
        { label: "火警", type: 0 },
        { label: "故障", type: 1 },
        { label: "屏蔽", type: 2 },
        { label: "反馈", type: 3 },
        { label: "动作", type: 4 },
      ],
      // moduleId: "",
      // orgId: "",
      getDates: getDate,
    };
  },
  computed: {
    showLoadMore() {
      return !this.loading && !this.noMoreData;
    },
  },
  methods: {
    handleTabChange(index) {
      this.tabType = index;
      this.resetPoliceLogList();
      this.getPoliceLogList(index);
    },
    resetPoliceLogList() {
      this.policeLogList = [];
      this.currentPage = 1;
      this.loading = false;
      this.noMoreData = false;
    },
    handleScroll() {
      if (this.scrollTimer) return;

      this.scrollTimer = setTimeout(() => {
        const logList = this.$refs.logList;
        if (
          logList.scrollTop + logList.clientHeight >=
            logList.scrollHeight - 10 &&
          this.showLoadMore
        ) {
          this.getPoliceLogList(this.tabType);
        }
        this.scrollTimer = null;
      }, 200);
    },
    async getPoliceLogList(tabType) {
      if (!this.showLoadMore) return;

      this.loading = true;
      try {
        const params = {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          orgId: this.orgId,
          sources: "3,6,7",
          sortFields: "ctime",
          hostId: this.moduleId,
        };

        if (tabType >= 2 && tabType <= 4) {
          if (tabType == 4) {
            params.types = this.getHointTypeByTabType(tabType);
          } else {
            params.type = this.getHointTypeByTabType(tabType);
          }
        } else if (tabType === 0) {
          params.alarmType = 0;
        }

        const response = await this.$Axios({
          url: this.getUrlApiByTabType(tabType),
          type: "get",
          obj: params,
        });
        if (response.data.data.length > 0) {
          this.policeLogList = [...this.policeLogList, ...response.data.data];
          this.currentPage++;
        } else {
          this.noMoreData = true;
        }
      } catch (err) {
        console.error("Failed to fetch police log list:", err);
      } finally {
        this.loading = false;
      }
    },
    getUrlApiByTabType(tabType) {
      const urlMap = {
        0: "/mcbw/auto_fire_alarms/fire_alarm",
        1: "/mcbw/auto_fire_alarms/fault",
        2: "/mcbw/actions",
        3: "/mcbw/actions",
        4: "/mcbw/actions",
      };
      return urlMap[tabType] || "";
    },
    getHointTypeByTabType(tabType) {
      const typeMap = {
        2: 801,
        3: 806,
        4: "802,803,808,811,812,813,814,815,818,819,820,821",
      };
      return typeMap[tabType];
    },
  },
  mounted() {
    this.getPoliceLogList(this.tabType);
    this.$refs.logList.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }
    this.$refs.logList.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    intervalIndex(res) {
      if (res == 0) {
        this.policeLogList = [];
        this.currentPage = 1;
        this.loading = false;
        this.noMoreData = false;
        this.getPoliceLogList(this.tabType);
      }
    },
  },
};
</script>

<style scoped lang="less">
.police-log {
  .police-log-title {
    margin-bottom: 10px;
    .title {
      font-size: 20px;
      font-weight: bold;
      color: #fff;
    }
    ul {
      list-style: none;
      li {
        display: inline-block;
        margin-left: 10px;
        cursor: pointer;
        border-radius: 4px;
        padding: 3px 10px;
        background-color: rgba(243, 244, 246, 0.5);
        color: #74D9FF;
        &.active {
          color: #fff;
          background-color: #1890ff;
          border-color: #1890ff;
        }
      }
    }
  }
  .police-log-list {
    min-height: 100px;
    height: ~"calc(50vh - 146px)";
    overflow-y: scroll;
    ul {
      list-style: none;
      li {
        border-radius: 12px;
        background: rgba(152, 50, 50, 0.5);
        box-sizing: border-box;
        border: 1px solid #E41717;
        padding: 10px;
        margin-bottom: 10px;
        h3 {
          font-size: 16px;
          font-weight: normal;
          line-height: 24px;
          color: #ff0c0c;
        }
        span {
          font-size: 14px;
          line-height: 20px;
          color: #74D9FF;
        }
        .text {
          margin-top: 5px;
          font-size: 14px;
          line-height: 20px;
          color: #74D9FF;
        }
      }
    }
  }
  .no-more-data {
    text-align: center;
    padding: 10px;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/remote-control/components/PoliceLog.vue